var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCdBabyLogoinline = function SvgCdBabyLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 21,
    viewBox: "0 0 19 21"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#72C1C5",
    d: "m10.727 5.145-.063-.031L1.631.176 1.505.108C1.368.038 1.205 0 1.037 0 .475 0 .02.423.007.96L0 .984l.007.025v9.899L0 10.934l.007.025c.012.537.468.96 1.03.96.144 0 .282-.025.407-.075l.193-.108 9.015-4.924.075-.044a.96.96 0 0 0 .45-.808.963.963 0 0 0-.45-.815"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5CB33",
    d: "m14.702 15.517-.05-.024-7.682-3.995-.101-.055a.946.946 0 0 0-.4-.092c-.481 0-.868.348-.88.775v8.1c.012.433.399.774.88.774a.92.92 0 0 0 .343-.06l.17-.086 7.663-3.989.063-.03a.787.787 0 0 0 .38-.66.779.779 0 0 0-.386-.658"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA883E",
    d: "m18.751 8.94-.032-.018-4.97-2.58-.07-.038a.607.607 0 0 0-.257-.06c-.314 0-.563.226-.57.503v5.235c.007.277.256.504.57.504a.691.691 0 0 0 .224-.042l.102-.056 4.965-2.575.038-.024A.493.493 0 0 0 19 9.364a.492.492 0 0 0-.249-.424"
  }))));
};
export default SvgCdBabyLogoinline;